export const useTitle = () => {
  return '| CreatorBay'
}

export default useTitle
